import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../presentation/assets/static/sort-blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-45c523d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("th", _hoisted_1, [
    _createElementVNode("span", {
      class: "table-header__content",
      title: `Ordenar por ${_ctx.text.toLowerCase()}`,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeOrder && _ctx.changeOrder(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(['table-header__text', _ctx.orderClass])
      }, _toDisplayString(_ctx.text), 3),
      _createElementVNode("img", {
        class: _normalizeClass(['table-header__icon', _ctx.orderClass]),
        src: _imports_0,
        alt: "Ícone de ordenação"
      }, null, 2)
    ], 8, _hoisted_2),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}